import React, { useContext, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setSelectedDeviceMine } from "../../redux";
import { ProfileSection } from "../../context/ProfileContext";
import { FiHardDrive, FiTrash2, FiArrowLeft, FiList } from "react-icons/fi";
import Cookies from "js-cookie";
import { Alert } from "../Alert";
import { DeviceMineContext } from "../../context/DeviceMineContext";
import { useTranslation } from "react-i18next";

const DeviceMine = () => {
  const { t } = useTranslation();
  const { deviceMine, setDeviceMine } = useContext(DeviceMineContext);
  const { ProfileShowHideFunc } = useContext(ProfileSection);
  const dispatch = useDispatch();
  const token = Cookies.get("token");
  const [deviceSerial, setDeviceSerial] = useState("");
  const [updateDeviceMine, setUpdateDeviceMine] = useState(deviceMine);
  const [submitAlert, setSubmitAlert] = useState(false);
  const userInfo = useSelector((state) => state.userProfileInfo);

  const deviceInfoPage = (device) => {
    dispatch(setSelectedDeviceMine(device));
    ProfileShowHideFunc("deviceInfo");
  };
  
  const [showAlert, setShowAlert] = useState({
    show: false,
    message: "",
    type: "",
    request: "",
    question: "",
  });
  
  const toggleAlert = (x) => {
    setShowAlert(!showAlert);
    if (x) {
      const y = updateDeviceMine.filter((d, i) => {
        return d.serial !== deviceSerial;
      });
      setDeviceMine(y);
      console.log(deviceMine);
    }
  };

  const handleDeviceDisjoint = (device) => {
    setDeviceSerial(device.serial);
    setShowAlert((prevState) => ({
      ...prevState,
      show: true,
      message: t("آیا دستگاه ") + t(`${device.caption}`) + t(" حذف گردد؟"),
      type: "Warning",
      question: true,
      request: "DeleteDeviceDisjoint",
    }));
  };

  return (
    <div className="setting-container" style={{ minHeight: "90vh" }}>
      <h2 className="setting-title">{t("لیست دستگاه ها")}</h2>

      {/* Devices List */}
      <div className="devices-list">
        {deviceMine?.map((device, index) => {
          return (
            <div
              key={index}
              onClick={() => deviceInfoPage(device)}
              className="device-item"
            >
              <div className="device-icon">
                {device.category.image !== "MPX4.jpg" ? (
                  <img src={device.category.image} className="device-img" alt="device" />
                ) : (
                  <FiHardDrive size={32} />
                )}
              </div>
              <div className="device-info">
                <p className="device-caption">{device.caption}</p>
                <p className="device-description">{device.category.description}</p>
                <p className="device-serial">{device.serial}</p>
              </div>
              <button
                className="device-delete-btn"
                onClick={(e) => {
                  e.stopPropagation();
                  handleDeviceDisjoint(device);
                }}
                title={t("حذف دستگاه")}
              >
                <FiTrash2 size={18} />
              </button>
            </div>
          );
        })}
      </div>

      {/* Back Button */}
      <div className="setting-buttons">
        <button
          type="button"
          className="setting-back-btn"
          onClick={() => ProfileShowHideFunc("firstPage")}
          style={{ background: "var(--bg-white)", color: "var(--text-primary)", border: "2px solid var(--border-color)" }}
        >
          <FiArrowLeft size={18} />
          <span>{t("بازگشت")}</span>
        </button>
      </div>

      {showAlert.show && (
        <Alert
          message={showAlert.message}
          type={showAlert.type}
          question={showAlert.question}
          request={showAlert.request}
          deviceSerial={deviceSerial}
          toggleAlert={toggleAlert}
          setSubmitAlert={setSubmitAlert}
        />
      )}
    </div>
  );
};

export { DeviceMine };